import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { RiDatabase2Line } from '@remixicon/react';

const subsetsRouteRef = createRouteRef();
const subsetDetailsRouteRef = createRouteRef({ params: ['subsetId'] });

const subsetsPage = PageBlueprint.make({
  params: {
    path: '/subsets',
    title: 'Database Subsets',
    icon: <RiDatabase2Line />,
    routeRef: subsetsRouteRef,
    noHeader: true,
    loader: async () =>
      import('./DatabaseSubsettingPage').then(module => (
        <module.DatabaseSubsettingPage />
      )),
  },
});

const subsetDetailsPage = PageBlueprint.make({
  name: 'details',
  params: {
    path: '/subsets/:subsetId',
    title: 'Subset Details',
    routeRef: subsetDetailsRouteRef,
    noHeader: true,
    loader: async () =>
      import('./DatabaseSubsettingPage').then(module => (
        <module.DatabaseSubsettingPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'database-subsetting',
  extensions: [subsetsPage, subsetDetailsPage],
});
